import React, { useState } from "react";
import { X, MessageCircle, Send } from "lucide-react";

const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  // Your official WhatsApp number (Include country code, no + or dashes)
  const phoneNumber = "916282003636";

  // Default message the user will send to you
  const defaultMessage =
    "Hello Maroons Business Solutions! I would like to know more about your services.";

  const handleWhatsAppRedirect = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;
    window.open(url, "_blank");
    setIsOpen(false); // Optional: close widget after clicking
  };

  return (
    <>
      {/* Floating Chat Button */}
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="fixed bottom-6 right-6 h-16 w-16 bg-gradient-to-br from-maroon-600 to-maroon-800 text-white rounded-full shadow-2xl hover:scale-110 transition-all duration-300 flex items-center justify-center z-50 group"
        >
          <MessageCircle className="h-7 w-7" />
          <span className="absolute -top-1 -right-1 h-4 w-4 bg-green-500 rounded-full border-2 border-white animate-pulse"></span>
        </button>
      )}

      {/* Chat Prompt Window */}
      {isOpen && (
        <div className="fixed bottom-6 right-6 w-80 md:w-96 bg-white rounded-2xl shadow-2xl flex flex-col z-50 border border-gray-200 overflow-hidden animate-in fade-in slide-in-from-bottom-10 duration-300">
          {/* Header */}
          <div className="bg-gradient-to-r from-maroon-600 to-maroon-800 text-white p-4 flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="h-10 w-10 bg-white rounded-full flex items-center justify-center shrink-0">
                <MessageCircle className="h-6 w-6 text-maroon-600" />
              </div>
              <div>
                <h3 className="font-bold text-lg leading-tight">Live Chat</h3>
                <p className="text-xs text-maroon-100 font-medium">
                  We typically reply in minutes
                </p>
              </div>
            </div>
            <button
              onClick={() => setIsOpen(false)}
              className="hover:bg-maroon-700/50 rounded-lg p-1.5 transition-colors"
            >
              <X className="h-5 w-5" />
            </button>
          </div>

          {/* Body Content */}
          <div className="p-6 bg-gray-50 flex flex-col items-center text-center space-y-4">
            <div className="bg-white p-4 rounded-2xl shadow-sm border border-gray-100 relative">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-0 h-0 border-l-8 border-r-8 border-b-8 border-transparent border-b-white"></div>
              <p className="text-gray-700 text-sm leading-relaxed">
                Hello! 👋 <br />
                Need help scaling your business? Click below to chat with our
                team directly on WhatsApp.
              </p>
            </div>

            {/* WhatsApp Call to Action Button */}
            <button
              onClick={handleWhatsAppRedirect}
              className="w-full bg-[#25D366] hover:bg-[#20bd5a] text-white font-bold py-3 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2 group"
            >
              <MessageCircle className="h-5 w-5 group-hover:scale-110 transition-transform" />
              Start Chat on WhatsApp
            </button>
          </div>

          {/* Footer */}
          <div className="bg-white p-3 text-center border-t border-gray-100">
            <p className="text-xs text-gray-400">
              Official Support • +91-628-200-3636
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatWidget;
